var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", {
      ref: "barchart",
      staticClass: "echartbox",
      style: { width: _vm.chartWidth, height: _vm.chartHeight },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }